module.exports = __webpack_public_path__ + "nc_static/media/sw-update-diabled.978e3d07.svg";